import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconDeliveryStyle0 = cosmosIconCss;

const CosmosIconDelivery$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDelivery extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'd0fe329d0a4cb9f854907cbdab0539b5f350e19b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e66e0d1dae56b708f301f358a7bb2440025a54b7', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '36038e2e81069f676135fe23f26ed19560c9d845', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13 9.5v-3h3.08l1.89 3H13Zm0 4V11h5.5v2.5H13Zm2.53 4.5a1.5 1.5 0 1 1-.06-2.999A1.5 1.5 0 0 1 15.53 18Zm-12-4.5v-9h8v9h-8Zm3 4.5a1.5 1.5 0 1 1 1.024-.432A1.5 1.5 0 0 1 6.48 18h.05Zm0 1.5a3 3 0 0 0 3-3A2.75 2.75 0 0 0 9 15h4a2.81 2.81 0 0 0-.44 1.52 3 3 0 1 0 6 0 2.68 2.68 0 0 0-.48-1.52h1.42a.5.5 0 0 0 .5-.5v-4.33a.61.61 0 0 0-.08-.38l-2.87-4.55a.5.5 0 0 0-.42-.24H13V3.5a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h1.43a2.69 2.69 0 0 0-.45 1.5 3 3 0 0 0 3.01 3h.04Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconDeliveryStyle0; }
}, [1, "cosmos-icon-delivery", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-delivery"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-delivery":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDelivery$1);
            }
            break;
    } });
}

const CosmosIconDelivery = CosmosIconDelivery$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDelivery, defineCustomElement };
